import { createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../../toast/reducer";
import { editUser as editUserAPI, fetchProfile as fetchProfileAPI } from "../../../helpers/apis";

export const editUser = createAsyncThunk(
  "profile/editUser",
  async ({ data }, thunkAPI) => {  // Accept `id`
    try {
      const response = await editUserAPI(data); 
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
        return response;
      } else {
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      return thunkAPI.rejectWithValue(error.msg);
    }
  }
);


export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const response = await fetchProfileAPI();

      if (!response.error) {
        return response; // Successfully retrieved profile data
      } else {
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      return thunkAPI.rejectWithValue(error.msg);
    }
  }
);